import styled from 'styled-components';
import { BasketScrappageDetailsStyled } from '../../BasketScrappageDetailsStyled';
import { rem } from 'polished';

export const BasketScrappageDetailsOV = styled(BasketScrappageDetailsStyled)`
    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h3};
        }
    }

    .description {
        font-family: ${({ theme }) => theme.fonts.fontSecondary};
    }

    .sections {
        .inner {
            .description {
                font-family: ${({ theme }) => theme.fonts.fontSecondary};
            }
        }
    }

    .summary {
        p {
            font-family: ${({ theme }) => theme.fonts.fontSecondary};
        }
    }
`;
